import { createGlobalStyle } from 'styled-components';
export const NavOverrideStyles = createGlobalStyle(() => {
  const navStyles = {
    'padding-inline': '0.5rem !important',
    // 8px at default zoom

    // Remove padding on mobile (1079px and below to avoid overlap at 1080px)
    ['@media (max-width: 67.4375rem)']: {
      'padding-inline': '0 !important'
    }
  };
  const loadingNavStyles = {
    maxWidth: '100% !important',
    paddingInline: 'max(0.5rem, calc((100% - 95.5rem) / 2)) !important'
  };

  /* Reserve vertical space for header/footer loading stencils. Without min-height
   * the divs are 0px until the async embed-nav script injects content, producing
   * CLS shifts whenever either element is in the viewport.
   * !important overrides any reset from embed.css. */
  const headerLoadingNavStyles = {
    minHeight: '8rem !important',
    // 128px desktop
    ['@media (max-width: 67.4375rem)']: {
      minHeight: '3.5rem !important' // 56px mobile
    }
  };
  const footerLoadingNavStyles = {
    minHeight: '40.9375rem !important',
    // 655px measured at 1080px–1440px
    ['@media (max-width: 67.4375rem)']: {
      minHeight: '46.25rem !important' // 740px measured at 768px
    },
    ['@media (max-width: 23.4375rem)']: {
      minHeight: '48.4375rem !important' // 775px measured at 320px
    }
  };
  return {
    // Apply styles to loaded navigation
    ['.hs-global-nav .global-nav-header .global-nav-content-section']: navStyles,
    // Apply styles to loading stencils
    ['.hs-global-nav-loading']: loadingNavStyles,
    // Reserve header/footer heights before async nav loads to prevent CLS
    ['.hs-global-nav-header.hs-global-nav-loading']: headerLoadingNavStyles,
    ['.hs-global-nav-footer.hs-global-nav-loading']: footerLoadingNavStyles,
    // Prevent "About" dropdown from overflowing the right edge of the viewport
    ['#global-nav-dropdown-list-utility_about']: {
      right: '0px'
    }
  };
});